export default __webpack_public_path__ + "static/media/Blog12.13.00aa7206.png";